import React, { useState, useEffect } from "react";
import server from "../variables";
import * as XLSX from "xlsx";
import { useParams } from "react-router-dom";
import { showError, showSuccess } from '../helperfunction/sweetalert.js'
const BillGenerateReport = ({ showModal, setShowModal }) => {
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [scheme, setScheme] = useState("");
  const [schemes, setSchemes] = useState([]);
const { id } = useParams();
  console.log('id',id)

  useEffect(() => {
    fetch("/api/schemes")
      .then((res) => res.json())
      .then((data) => setSchemes(data))
      .catch((err) => console.log(err));
  }, []);


  useEffect(() => {
    if (showModal) {
      setMonth("");
      setYear("");
        setScheme(id || "");
    }
  }, [showModal,id]);

const generateReport = async () => {
  if (!month || !year || !scheme) {
    showError("Month, Year aur Scheme are required"); // alert ki jagah showError use karo
    return;
  }

  try {
    const response = await fetch(
      `${server}admin/export-bills?month=${month}&year=${year}&scheme=${scheme}`
    );

    const result = await response.json(); 
    const bills = result.data;

    if (!bills || bills.length === 0) {
      showError("No bills found for selected Month/Year/Scheme");
      return;
    }

    const formattedData = formatBillsForExcel(bills);
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    worksheet['!cols'] = [
      { wch: 15 }, // BILL ID
      { wch: 25 }, // CONSUMER ID
      { wch: 25 }, // CONSUMER NAME
      { wch: 20 }, // SCHEME NAME
      { wch: 20 }, // METER NUMBER
      { wch: 15 }, // FIXED CHARGE
      { wch: 15 }, // OTHER CHARGES
      { wch: 20 }, // TOTAL BILL AMOUNT
      { wch: 10 }, // MONTH
      { wch: 20 }, // YEAR
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bills");
    XLSX.writeFile(workbook, "Bill_Report.xlsx");

    setShowModal(false);
    showSuccess("Report generated successfully!"); // ✅ success alert
  } catch (err) {
    console.error(err);
    showError("error"); // error alert
  }
};


const formatBillsForExcel = (bills) => {
  return bills.map((bill) => ({
    "BILL ID": bill.billID || "",
    "CONSUMER ID": bill.consumerID || "",
    "CONSUMER NAME": bill.otherDetails?.consumerName || "",
    "Father Name": bill?.fatherHusbandName || "",
     "Ward Number":bill?.wardNumber || "",
    "SCHEME NAME": bill.otherDetails?.schemeName || "",
    "MONTH": bill.month || "",
    "YEAR": bill.year || "",
    "FIXED CHARGE": bill.fixedCharges || 0,
    "OTHER CHARGES": bill.otherCharges || 0,
    "TOTAL BILL AMOUNT": bill.fixedCharges || 0,
     
  }));
};

  if (!showModal) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Generate Bill Report</h5>
            <button
              className="btn-close"
              onClick={() => setShowModal(false)}
            ></button>
          </div>

          <div className="modal-body">
            {/* Month */}
            {/* Month */}
            <div className="mb-3">
              <label className="form-label">Month</label>
              <select
                className="form-select"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
              >
                <option value="">Select Month</option>
                {[
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ].map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div>

            {/* Year */}
            <div className="mb-3">
              <label className="form-label">Year</label>
              <select
                className="form-select"
                value={year}
                onChange={(e) => setYear(e.target.value)}
              >
                <option value="">Select Year</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
              </select>
            </div>

            {/* Scheme */}
            <div className="mb-3">
              <label className="form-label">Scheme</label>
              <input
                type="text"
                className="form-control"
                value={id}
                onChange={(e) => setScheme(e.target.value)}
                placeholder="Enter Scheme Name"
              />
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn btn-success" onClick={generateReport}>
              <i className="bi bi-file-earmark-excel"></i> Generate Excel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillGenerateReport;
